<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <AdminKycBack title="Участник" @back="handleBack" />

    <div :class="b('form')">
      <div :class="b('form-group')">
        <div :class="b('form-block')">
          <h4 :class="b('form-title')">
            {{ $t("Паспорт или ВУ") }}
          </h4>

          <div :class="b('form-fields', { passport: true })">
            <SharedUpload
              :document="documents['kyb-participant-documents-passport-selfie']"
              :is-readonly="true"
              :is-download="true"
            >
              <template #label>
                {{ $t("Страница") }} <br />
                {{ $t("с фото") }}
              </template>
            </SharedUpload>

            <SharedUpload
              :document="
                documents['kyb-participant-documents-passport-organization']
              "
              :is-readonly="true"
              :is-download="true"
            >
              <template #label>
                {{ $t("Страница") }} <br />
                {{ $t("кем выдан") }}
              </template>
            </SharedUpload>

            <SharedUpload
              :document="
                documents['kyb-participant-documents-passport-address']
              "
              :is-readonly="true"
              :is-download="true"
            >
              <template #label>
                {{ $t("Страница") }} <br />
                {{ $t("с пропиской") }}
              </template>
            </SharedUpload>
          </div>
        </div>

        <div :class="b('form-block')">
          <h4 :class="b('form-title')">
            {{ $t("Селфи") }}
          </h4>

          <div :class="b('form-fields', { selfie: true })">
            <SharedUpload
              :document="documents['kyb-participant-documents-selfie']"
              :is-readonly="true"
              :is-center="true"
              :is-download="true"
            />
          </div>
        </div>
      </div>

      <div :class="b('form-block')">
        <h4 :class="b('form-title')">
          {{ $t("Соглашения") }}
        </h4>

        <div :class="b('form-fields', { agreements: true })">
          <SharedUpload
            :document="documents['kyb-participant-documents-questionnaire']"
            :is-readonly="true"
            :is-download="true"
          >
            <template #label>
              {{ $t("Анкета физического лица") }} <br />
              {{ $t("(подписанная учредителем)") }}
            </template>
          </SharedUpload>

          <SharedUpload
            :document="documents['kyb-participant-documents-personal-data']"
            :is-readonly="true"
            :is-download="true"
          >
            <template #label>
              {{ $t("Согласие на обработку") }} <br />
              {{ $t("персональных данных") }}
            </template>
          </SharedUpload>
        </div>
      </div>

      <div v-if="files.length" :class="b('form-block')">
        <h4 :class="b('form-title')">
          {{ $t("Документы для подтверждения верификации") }}
        </h4>

        <div :class="b('form-fields', { verification: true })">
          <SharedUpload
            v-for="file in files"
            :key="file.uuid"
            :class="b('form-upload')"
            :document="file"
            :is-readonly="true"
            :is-download="true"
          >
            <template #label>
              {{ file.name }}
            </template>
          </SharedUpload>
        </div>
      </div>
    </div>
  </div>
</template>
